import { useMemo } from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import {
  FormItem,
  Input,
  Form,
  AutoComplete,
  Container,
  SubmitButton,
  Loading,
} from '../../../components';
import { useCallManagement } from './useCallManagement';
import type { CallManagementFormProps } from './useCallManagement';
import { validatePhone, validatePin } from '../validator';

export const OutboundCall = () => {
  const {
    agentsOptions,
    onChange,
    form,
    handleCall,
    isCalling,
    outboundPhones,
    isAgentsLoading,
  } = useCallManagement();

  const isDisabled = useMemo(() => {
    return (
      !form?.agentId || !form?.phone || !form?.outboundPhoneId || isCalling
    );
  }, [form?.agentId, form?.outboundPhoneId, form?.phone, isCalling]);

  return (
    <>
      {isAgentsLoading ? (
        <Loading />
      ) : (
        <div className="flex items-center justify-center min-h-[80vh] px-4">
          <Container className="w-full sm:max-w-lg md:max-w-xl lg:max-w-2xl xl:max-w-3xl">
            <Form
              onChange={onChange}
              initialValue={form as CallManagementFormProps}
            >
              <div className="flex flex-col gap-y-4">
                <FormItem<CallManagementFormProps>
                  required
                  name="agentId"
                  label="Select Agent"
                  className="w-full"
                  inline={false}
                >
                  <AutoComplete options={agentsOptions || []} />
                </FormItem>
                <FormItem<CallManagementFormProps>
                  name="outboundPhoneId"
                  required
                  label="Outbound SIP trunk phone number to call from"
                  className="w-full"
                  inline={false}
                >
                  <AutoComplete
                    options={outboundPhones || []}
                    placeholder="Phone Number"
                  />
                </FormItem>

                <FormItem<CallManagementFormProps>
                  name="phone"
                  label="Destination User Phone Number"
                  validate={validatePhone}
                  required={!!form?.agentId}
                  className="w-full"
                  inline={false}
                >
                  <Input
                    disabled={!form?.agentId}
                    placeholder="Enter Phone Number"
                  />
                </FormItem>

                <FormItem<CallManagementFormProps>
                  name="pinCode"
                  label="Google Meet PIN"
                  validate={validatePin}
                  className="w-full"
                  inline={false}
                >
                  <Input
                    disabled={!form?.agentId}
                    placeholder="Google Meet PIN"
                  />
                </FormItem>

                <FormItem<CallManagementFormProps>
                  name="backgroundInfo"
                  label="Background Information"
                  className="w-full"
                  inline={false}
                >
                  <Input
                    disabled={!form?.agentId}
                    multiline
                    placeholder="Background Information"
                  />
                </FormItem>

                <div className="flex justify-end w-full">
                  <SubmitButton
                    label="Call"
                    icon={<PhoneIcon />}
                    size="medium"
                    type="primary"
                    disabled={isDisabled}
                    onClick={handleCall}
                  />
                </div>
              </div>
            </Form>
          </Container>
        </div>
      )}
    </>
  );
};
